export enum RolesEnum {
  admin = 'admin',
  user = 'user',
}

